
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class extends Vue {
  private posters = [
    { icon: require('@/assets/images/01.png'), url: 'https://www.acftu.org/xwdt/ghyw/202110/t20211018_786980.html?7OkeOa4k=qAqicArjSZICuEwD27iKToD3XSB5bP9c3UMonuUklfaqqhsKH_wZqAqqMa' },
    { icon: require('@/assets/images/02.png'), url: process.env.VUE_APP_ACTIVITY_URL }
  ]

  goDetail (item: any) {
    window.open(item.url)
  }
}
